function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "19.962",
  height: "19.964"
}, props), /*#__PURE__*/React.createElement("text", {
  transform: "translate(8.301 12.376)",
  fill: "#fff",
  fontSize: "6",
  fontFamily: "SegoeUI-Bold, Segoe UI",
  fontWeight: "700"
}, /*#__PURE__*/React.createElement("tspan", {
  x: "0",
  y: "0"
}, "5")), /*#__PURE__*/React.createElement("path", {
  d: "M4.553 14.529a7.081 7.081 0 01.872-9.977.644.644 0 11.827.986 5.794 5.794 0 108.164.715 5.7 5.7 0 00-4.747-2.052.644.644 0 01-.07-1.286A7.082 7.082 0 114.553 14.53z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.177 3.482l2.619 1.743a.339.339 0 00.525-.28V1.464a.338.338 0 00-.525-.28L8.177 2.927a.335.335 0 000 .556z",
  fill: "#fff"
})));